<app-card-base [title]="'Réinitalisez votre mot de passe'" [hasSubmit]="true" [submitText]="'Réinitialiser'"
  (onSubmitEvent)="onSubmit()" [loading]="loading" [isDisabled]="passwordLostForm.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
  <ng-container footer *ngTemplateOutlet="footer"></ng-container>
</app-card-base>

<ng-template #content>
  <div class="text-center">
    <p>Saisissez votre adresse email pour lancer la procédure de réinitialisation.</p>
    <p>Vous recevrez un email avec votre nouveau mot de passe.</p>
  </div>
  <form [formGroup]="passwordLostForm" class="mt-3" (ngSubmit)="onSubmit()">
    <div class="field-center">
      <mat-form-field>
        <mat-label>Adresse Email</mat-label>
        <input matInput type="email" required formControlName="email" placeholder="" />
        <mat-error *ngIf="f('email').hasError('required')">
          <span>Veuillez saisir votre adresse email</span>
        </mat-error>
        <mat-error *ngIf="f('email').hasError('email')">
          <span>Veuillez saisir une adresse email valide</span>
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</ng-template>

<ng-template #footer>
  <div class="d-flex flex-row-reverse">
    <button mat-flat-button color="primary" routerLink="/login" [queryParams]="getQueryParams()">Retour</button>
  </div>
</ng-template>